import './ListingItem.css';
import React from 'react';
import { getGlobalDictionaryTerm, getMediaHost, injectImageResolution, pathJoin } from '../../../../utils';
import LazyPicture from '../../LazyPicture';
import FavouriteBtn from '../../FavouriteBtn/FavouriteBtn';
import RouterLink from '../../RouterLink';
import { tealiumClickFunc, tealiumMergeClickData } from '../../../../utils/tealium';
import { SitecoreContextReactContext } from '../../../../utils/SitecoreContextReactContext';
import { HighlighterHOC } from '../../HighlighterHOC/HighlighterHOC';
const ListingItem = _ref => {
  let {
    item,
    rtl,
    color,
    isActiveItem,
    analytics,
    params,
    getActivePopupOnMap,
    isCarousel,
    activeTopPicks,
    toggleActiveTopPicks,
    withHighlightText = false,
    searchString = ''
  } = _ref;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const addToFavorites = getGlobalDictionaryTerm(sitecoreContext, 'addToFavorites') || 'add To Favorites';
  const removeFromFavorites = getGlobalDictionaryTerm(sitecoreContext, 'removeFromFavorites') || 'remove from Favorites';
  const {
    objectID,
    image = '',
    title,
    englishTitle,
    url,
    type,
    tripadvisorImage,
    tripadvisorReviews,
    tripadvisorScore,
    _geoloc: {
      lng
    },
    _geoloc: {
      lat
    }
  } = item;
  const formatNum = n => n >= 1000 ? `${(n / 1000).toFixed(1)}К` : `${n}`;
  const imgSrc = injectImageResolution(`${pathJoin([getMediaHost(), image])}`, 75, 56);
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: `imfilters-listing-item ${isActiveItem ? 'active' : ''}`,
    style: {
      '--m114-listing-item-color': color
    }
  }, /*#__PURE__*/React.createElement(LazyPicture, {
    useEmptyPlaceholder: true
  }, /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 768px)",
    srcSet: imgSrc
  }), /*#__PURE__*/React.createElement("img", {
    className: "imfilters-listing-item__image",
    src: imgSrc,
    alt: title || englishTitle,
    "aria-hidden": "true"
  })), /*#__PURE__*/React.createElement("div", {
    className: "imfilters-listing-item__info"
  }, isCarousel ? /*#__PURE__*/React.createElement(React.Fragment, null, (title || englishTitle) && /*#__PURE__*/React.createElement(RouterLink, {
    openInSameTab: true,
    href: url,
    onClick: () => {
      tealiumClickFunc(tealiumMergeClickData(analytics['selectedItemAnalytics'], params), [type, title || englishTitle]);
    },
    title: title,
    className: `title ${isCarousel ? 'ellipsis1' : 'ellipsis2'}`
  }, title || englishTitle)) : /*#__PURE__*/React.createElement(React.Fragment, null, (title || englishTitle) && /*#__PURE__*/React.createElement("button", {
    type: "button",
    name: title || englishTitle,
    onClick: () => {
      getActivePopupOnMap({
        objectID,
        lat,
        lng
      });
      tealiumClickFunc(tealiumMergeClickData(analytics['selectedItemAnalytics'], params), [type, title || englishTitle]);
    },
    title: title,
    className: `title ${isCarousel ? 'ellipsis1' : 'ellipsis2'}`
  }, withHighlightText ? /*#__PURE__*/React.createElement(HighlighterHOC, {
    text: title,
    searchString: searchString
  }) : title || englishTitle)), /*#__PURE__*/React.createElement("div", {
    className: "imfilters-listing-item__tripadvisor"
  }, tripadvisorImage && /*#__PURE__*/React.createElement("div", {
    className: "tripadvisor-svg"
  }, /*#__PURE__*/React.createElement("img", {
    src: tripadvisorImage,
    alt: title || englishTitle,
    "aria-hidden": "true"
  })), tripadvisorReviews && /*#__PURE__*/React.createElement("span", {
    className: "tripadvisor-num"
  }, formatNum(Number(tripadvisorReviews))))), /*#__PURE__*/React.createElement(FavouriteBtn, {
    itemId: objectID,
    classes: 'imfilters-listing-item__fav-btn',
    activeListOnSamePage: activeTopPicks,
    multiplyButton: true,
    analyticsClick: e => {
      if (e === 'add to favorites') {
        tealiumClickFunc(tealiumMergeClickData(analytics['favoriteAnalytics'], params), [`${type} : ${title || englishTitle}`, `${addToFavorites}`]);
      } else {
        tealiumClickFunc(tealiumMergeClickData(analytics['favoriteAnalytics'], params), [`${type} : ${title || englishTitle}`, `${removeFromFavorites}`]);
      }
      toggleActiveTopPicks(objectID);
    }
  })));
};
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl
  } = _ref2;
  return /*#__PURE__*/React.createElement("div", {
    className: ` ${commonStyles}  ${rtl ? rtlStyles : ltrStyles}`
  }, children);
};
const commonStyles = "c11arr7l";
const ltrStyles = "l1ql5y0";
const rtlStyles = "rgujfd8";
export default ListingItem;